import { USER_DETAIL_RESULT, ROLE_DETAIL_RESULT } from "../actions/ActionType";

const readSessionStorageJson = (key) => {
  if (typeof sessionStorage === "undefined") {
    return {};
  }

  const storedValue = sessionStorage.getItem(key);

  if (!storedValue) {
    return {};
  }

  try {
    return JSON.parse(storedValue);
  } catch (error) {
    return {};
  }
};

export const initialState = {
  userDetails: readSessionStorageJson("passData"),
  roleDetails: readSessionStorageJson("roleData")
};

export const getUserDetailsReducer = (userInfo = initialState, action) => {
  switch (action.type) {
    case USER_DETAIL_RESULT:
    userInfo = {
        ...userInfo,
        userDetails: action.payload
      };
      break;
      case ROLE_DETAIL_RESULT:
    userInfo = {
        ...userInfo,
        roleDetails: action.payload
      };
      break;
    default:
  }
  return userInfo;
};
